import { render, staticRenderFns } from "./UserPermissionBulkUploadDialog.vue?vue&type=template&id=2fc5b82d&scoped=true"
import script from "./UserPermissionBulkUploadDialog.vue?vue&type=script&lang=js"
export * from "./UserPermissionBulkUploadDialog.vue?vue&type=script&lang=js"
import style0 from "./UserPermissionBulkUploadDialog.vue?vue&type=style&index=0&id=2fc5b82d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc5b82d",
  null
  
)

export default component.exports